export default {
  common: {
    langSwitch: '中文',
    backTop: 'Back to top',
  },
  privacy: {
    title: 'CeresGo Manager Privacy Policy',
    effectiveDate: 'Effective Date',
    effectiveDatePlaceholder: 'Please update as appropriate',
    intro: 'CeresGo Manager (referred to as "this App" or "we") is operated by Robo Motion, LLC. We value your privacy. This policy describes how we collect, use, store, and protect your personal information.',
    section1Title: '1. Information We Collect',
    section1_1Title: '1.1 Information You Provide',
    section1_1: [
      'Account & login: Phone number and email address for registration, login, and identity verification (including verification codes).',
      'Profile: Name, nickname, or other details you provide in the App (if applicable).',
      'Support: Contact details and content you provide when contacting customer support or submitting feedback.',
    ],
    section1_2Title: '1.2 Information We Collect Automatically',
    section1_2: [
      'Device & usage: Device model, OS version, app version, usage duration, page visits, etc., to ensure service operation and improve experience.',
      'Crash & diagnostics: We use Sentry and similar tools to collect crash reports, error logs, and performance data to troubleshoot and improve app stability. Privacy policy:',
    ],
    section1_3Title: '1.3 Information From Your Use of Features',
    section1_3: [
      'Replenishment: Images you upload (e.g. replenishment proof, site photos) are used only for business purposes and stored in accordance with applicable law.',
    ],
    section1NoCollect: 'We do not collect your precise location (GPS), contacts, or other local files you have not actively uploaded.',
    section2Title: '2. How We Use This Information',
    section2List: [
      'Provide, maintain, and improve this App;',
      'Authenticate and manage your account and security;',
      'Send verification codes and necessary service or security-related notices (if you opt in);',
      'Analyze usage and crash data to improve the product;',
      'Process replenishment records, tickets, and support requests you submit;',
      'Comply with applicable laws or respond to lawful requests from authorities.',
    ],
    section2NoUse: 'We do not use your personal information for marketing unrelated to the above purposes, nor do we sell your personal information to third parties.',
    section3Title: '3. Storage and Security',
    section3: 'We use reasonable technical and organizational measures to protect your personal information from unauthorized access, use, or disclosure. Your data is retained for as long as necessary to fulfill the purposes in this policy or as required by law.',
    section4Title: '4. Third-Party Services',
    section4Intro: 'This App may use the following third-party services, which process data according to their own privacy policies:',
    section4Sentry: 'Sentry: Error monitoring and performance analysis. Privacy policy:',
    section4Email: 'Email delivery (e.g. Alibaba Cloud): Sending verification codes or system notices. Service provider privacy policy:',
    section4Alibaba: 'Alibaba Cloud Privacy Policy',
    section4End: 'We only provide these providers with data necessary for the described functions. We recommend that you review their privacy policies.',
    section5Title: '5. Your Rights',
    section5Intro: 'Under applicable law, you may have the following rights (depending on your jurisdiction):',
    section5List: [
      'Access, correct, delete: Request access, correction, or deletion of your personal information via in-app settings or by contacting us.',
      'Withdraw consent: Where permitted by law, you may withdraw consent; we will stop the corresponding processing to the extent allowed.',
      'Complain: You have the right to lodge a complaint with a supervisory authority in your jurisdiction.',
    ],
    section5NoAuto: 'We do not make automated decisions that significantly affect you based solely on your personal information.',
    section6Title: '6. Minors',
    section6: 'This App is not directed at users under 13 (or the higher age in your jurisdiction). We do not knowingly collect personal information from such minors. If you believe we have collected such information, please contact us and we will delete it promptly.',
    section7Title: '7. Policy Updates',
    section7: 'We may update this policy from time to time. The updated version will be published in the App or on our website. We will notify you of material changes via in-app notice or other appropriate means. Continued use of the App constitutes acceptance of the updated policy.',
    section8Title: '8. Contact Us',
    section8Intro: 'If you have any questions, comments, or requests regarding this policy or your personal information, please contact us:',
    contactEmail: 'Email: info@robotceres.com',
    contactWeb: 'Website: https://robotceres.com/ceresgo/',
    contactPhone: '',
    section8End: 'We will respond to your request within a reasonable period.',
    footerCompany: 'Robo Motion, LLC',
    footerUpdate: 'Last updated as shown at the top of this policy.',
    sentryUrl: 'https://sentry.io/privacy/',
    sentryLinkText: 'Sentry Privacy Policy',
    alibabaUrl: 'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-privacy-policy',
  },
}
